//Importación librerías
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import highchartsMore from 'highcharts/highcharts-more'

highchartsMore(Highcharts)

exportingInit(Highcharts)

export default Chart



//////////////////
// WEBPACK FOOTER
// ./static/js/highchart.js
// module id = null
// module chunks = 